import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useRecorderUtils() {
    var _a = React.useState(), recorderElement = _a[0], setRecorderElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || recorderElement)
            return;
        var loadedRecorderElement = client.getRecorderElement();
        setRecorderElement(loadedRecorderElement);
    }, [client, setRecorderElement, recorderElement]);
    return recorderElement;
}
/**
* @deprecated Use `useRecorderEventCallback('recordingDone')` hook instead
*/
export function useRecorderAddHandler() {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.onRecordedData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
/**
* @deprecated Use `recorderUtils.getRecordingData()` method instead
*/
export function useRecordingDataByRecorderId(recorderId) {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.getRecordingDataByRecorderId(recorderId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
export function useRecordings(query) {
    var recorderElement = useRecorderUtils();
    var _a = React.useState([]), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the inputs
    var memoizedData = React.useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings(memoizedData).subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData([]);
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings, memoizedData]);
    return data;
}
